<template>
  <div class="results container-custom">
    <div class="results__banner" v-on:click="goToHome()">
      <img src="@/assets/images/ticket/banner.webp" />
    </div>
    <div class="results__title">
      RESULTS
    </div>
    <div class="results__lists">
      <div>
        <div class="nav nav-tabs nav-fill">
          <a
            v-for="(tab, index) in tabs"
            :key="index"
            class="nav-item nav-link"
            :class="[{active : tab.isActive}, tab.classCustom]"
            data-toggle="tab"
            :href="`#${tab.href}`"
            :aria-controls="tab.href"
            :aria-selected="tab.isActive"
            v-on:click="currentTab = tab"
          >{{ tab.title }}</a>
        </div>
        <component v-bind:is="currentTab.component" class="tab"></component>
      </div>
    </div>
  </div>
</template>
<script>
import TabListByDate from "./TabListByDate";
import TabListByName from "./TabListByName";
export default {
  data () {
    var tabs = [
      {
        name: "ByDate",
        title: 'LIST BY DATE',
        href: 'list-by-date',
        isActive: true,
        component: TabListByDate
      },
      {
        name: "ByName",
        title: 'LIST BY NAME',
        href: 'list-by-name',
        isActive: false,
        component: TabListByName
      }
    ];

    return {
      tabs: tabs,
      currentTab: tabs[0]
    }
  },
  methods: {
    goToHome() {
      this.$router.push({name: 'Home'})
    }
  }
}
</script>
<style scoped lang="scss" src="@/assets/scss/common/tab/tab-swift.scss"/>
<style scoped lang="scss" src="@/assets/scss/results/results.scss"/>
